import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewEncapsulation,
  isDevMode,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GLAMERA_ICON_HOST_TEMPLATE,
  GlameraIconDefinition,
} from '@glamera/animated-icons/core';
import { GlameraIconRegistry } from '../../icon-registry';

@Component({
  standalone: true,
  selector: 'glamera-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../../../core/src/lib/base/icon-base.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GlameraIconComponent extends GlameraIconBase {
  @Input() name = '';

  private static readonly warned = new Set<string>();

  constructor(
    sanitizer: DomSanitizer,
    cdr: ChangeDetectorRef,
    private readonly registry: GlameraIconRegistry
  ) {
    super(sanitizer, cdr);
  }

  get iconDef(): GlameraIconDefinition | undefined {
    const icon = this.registry.get(this.name);
    if (!icon && this.name && isDevMode() && !GlameraIconComponent.warned.has(this.name)) {
      GlameraIconComponent.warned.add(this.name);
      console.warn(
        `Glamera icon "${this.name}" is not registered. Call provideGlameraIcons() or GlameraIconsModule.withIcons() with this icon.`
      );
    }
    return icon;
  }
}
